var Vendd = (function (Vendd) {
    'use strict';

    Vendd.Tracking = (function (Tracking) {

        Tracking.Messages = (function (Messages) {

            Messages.ProductsUpdated = function (data) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Tracking.Messages.ProductsUpdated', data);
            };
            Messages.ProductsUpdated.className = 'Vendd.Tracking.Messages.ProductsUpdated';

            return Messages;

        })(Tracking.Messages || {});

        return Tracking;

    })(Vendd.Tracking || {});

    return Vendd;

})(Vendd || {});